export enum GenericSearchEvents {
  CategorySelected = "Search Category Selected",
  ContentTypeSelected = "Search Content Type Selected",
  ReportClicked = "Search Report Clicked",
  TagSelected = "Search Tag Selected",
  SortOrderSelected = "Search Sort Order Selected",
  PageNext = "Search Pagination Next Clicked",
  PagePrevious = "Search Pagination Previous Clicked",
}
